import {
  Component,
  Inject,
  ViewEncapsulation,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  VAIconRegistryService,
  closeCircle,
  infoCircle,
  arrowCircleRight,
  arrowCircleLeft,
} from "@va/core-library/icons";

@Component({
  selector: "app-company-announcement-dialog",
  templateUrl: "./company-announcement-dialog.component.html",
  styleUrls: ["./company-announcement-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyAnnouncementDialogComponent {
  @Output() closeClicked: EventEmitter<void> = new EventEmitter();
  @Output() onNextGuidanceClicked: EventEmitter<void> = new EventEmitter();
  @Output() onPrevGuidanceClicked: EventEmitter<void> = new EventEmitter();

  isLeftSidebarActive = false;
  isRightSidebarActive = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private iconRegistry: VAIconRegistryService,
    private dialogRef: MatDialogRef<CompanyAnnouncementDialogComponent>,
  ) {
    this.iconRegistry.registerIcons([
      closeCircle,
      infoCircle,
      arrowCircleRight,
      arrowCircleLeft,
    ]);
  }
  closeDialog() {
    this.closeClicked.emit();
  }
  onNextGuidance() {
    this.onNextGuidanceClicked.emit();
  }

  onPrevGuidance() {
    this.onPrevGuidanceClicked.emit();
  }

  handleleftsidebarClick() {
    this.isLeftSidebarActive = !this.isLeftSidebarActive;
  }

  handleRightSidebarClick() {
    this.isRightSidebarActive = !this.isRightSidebarActive;
  }

  handleOpenInWindow(e) {
    e.preventDefault();
    this.closeClicked.emit();
    const url = `/company-announcements/
${this.data.ticker}/
${this.data.documentId}`;
    window.open(url, "_blank");
  }
}
